module.exports = __webpack_public_path__ + "img/footer_wave@2x.25463c87.jpg";